<div
    #modal="bs-modal"
    [config]="{ backdrop: 'static' }"
    appBsModal
    aria-hidden="true"
    aria-labelledby="modal"
    class="modal fade"
    role="dialog"
    tabindex="-1"
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    <span>
                        {{ "AreYouSureYouWantToCopyDataFrom" | localize }}
                    </span>
                    <span class="highlight-element">
                        {{ options | date: "dd/MM/yy" }}
                    </span>
                    <span>
                        ?
                    </span>
                </h4>
            </div>

            <div class="footer">
                <button
                    (click)="close()"
                    class="btn btn-secondary font-weight-bold"
                    type="button"
                >
                    {{ "Cancel" | localize }}
                </button>
                <button
                    (click)="copy()"
                    class="btn btn-primary font-weight-bold"
                    type="button"
                >
                    {{ "Copy" | localize }}
                </button>
            </div>
        </div>
    </div>
</div>
